import { CommandPage } from "@/lib/command"

import type {
  ActiveCallResponse,
  CallControlRequest,
  CallControlResponse,
} from "./types"

export const ACTIVE_CALL_COMMAND_PATH = "/app/crm/base/cmd/calls/active"

export async function loadActiveCall(): Promise<ActiveCallResponse> {
  const result = await CommandPage(ACTIVE_CALL_COMMAND_PATH).load()
  const data = result.unwrap() as ActiveCallResponse
  return {
    active_call: data.active_call ?? null,
    calls: data.calls ?? [],
    system_call: data.system_call ?? null,
    realtime_cursor: data.realtime_cursor ?? null,
    realtime_state: data.realtime_state ?? "unavailable",
  }
}

export async function sendCallControl(
  request: CallControlRequest
): Promise<CallControlResponse> {
  const result = await CommandPage(ACTIVE_CALL_COMMAND_PATH).sendCallControl(request)
  return result.unwrap() as CallControlResponse
}
